// Module
var code = "<ul class=\"color-dots color-dots--size-{{::$ctrl.size}}\" ng-if=\"$ctrl.hasColorDots\"> <li class=\"color-dots__dot\" ng-repeat=\"colorDot in $ctrl.colorDots\"> <i ng-style=\"colorDot\"></i> </li> </ul>";
// Exports
module.exports = code;